var map = {
	"./doctor-01.jpg": 61648,
	"./doctor-02.jpg": 77977,
	"./doctor-03.jpg": 46504,
	"./doctor-04.jpg": 37481,
	"./doctor-05.jpg": 85043,
	"./doctor-06.jpg": 56737,
	"./doctor-07.jpg": 56858,
	"./doctor-08.jpg": 16969,
	"./doctor-09.jpg": 64993,
	"./doctor-10.jpg": 9801,
	"./doctor-11.jpg": 70375,
	"./doctor-12.jpg": 26125,
	"./doctor-thumb-01.jpg": 78991,
	"./doctor-thumb-02.jpg": 24567,
	"./doctor-thumb-03.jpg": 78105,
	"./doctor-thumb-04.jpg": 68003,
	"./doctor-thumb-05.jpg": 36652,
	"./doctor-thumb-06.jpg": 87048,
	"./doctor-thumb-07.jpg": 37217,
	"./doctor-thumb-08.jpg": 57454,
	"./doctor-thumb-09.jpg": 79446,
	"./doctor-thumb-10.jpg": 42228,
	"./doctor-thumb-11.jpg": 10902,
	"./doctor-thumb-12.jpg": 30074
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16760;